<section class="hero is-fullheight">
  <div class="hero-body">
    <div class="container has-text-centered">
      <div class="columns">
        <div class="column col-login">
          <div>
            <figure class="avatar">
              <img src="./assets/img/logo.svg" alt="logo Zèle" *ngIf="!isAlt" />
              <img
                src="./assets/img/logo-alt.svg"
                alt="logo Zèle SGE"
                *ngIf="isAlt"
              />
            </figure>
            <h3 class="title is-2 m-t-gutter m-b-sm">Mot de passe oublié</h3>
            <p class="m-b-gutter">
              Entrez votre e-mail pour recevoir un lien de réinitialisation.
            </p>
            <form [formGroup]="form" (submit)="submit()">
              <div class="field m-b-gutter">
                <div class="control">
                  <input
                    type="email"
                    formControlName="email"
                    class="input is-large"
                    placeholder="Votre e-mail*"
                  />
                </div>
              </div>

              <button
                type="submit"
                class="button is-block is-primary is-large is-fullwidth m-b-md"
              >
                Recevoir un lien de réinitialisation
              </button>
              <a routerLink="/login">Se connecter</a>
            </form>
          </div>
        </div>
        <div class="column col-decoration">
          <div class="drawing">
            <img src="../../../../assets/img/bg-3.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
